import { render, staticRenderFns } from "./OnlineCashTx.vue?vue&type=template&id=388d51a6&scoped=true&"
import script from "./OnlineCashTx.vue?vue&type=script&lang=js&"
export * from "./OnlineCashTx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d51a6",
  null
  
)

export default component.exports